const indexItems = [
  { title: '2024年度十佳电影', count: '10部', tag: '年度盘点' },
  { title: '豆瓣9分以上神作', count: '42部', tag: '高分推荐' },
  { title: '不可错过的国产剧', count: '68部', tag: '国产精选' },
  { title: '周末一口气刷完系列', count: '36部', tag: '短剧精选' },
  { title: '奥斯卡获奖影片全集', count: '85部', tag: '获奖佳作' },
  { title: '日韩高分剧集精选', count: '54部', tag: '海外剧集' },
  { title: '好莱坞动作大片合集', count: '72部', tag: '动作盛宴' },
  { title: '治愈系温情电影推荐', count: '28部', tag: '温情推荐' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">专题合集</h2>
          <p className="mt-2 text-sm text-foreground-500">精心策划的影视专题，发现更多高质量内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.title}
              className="p-5 rounded-lg bg-background-100 border border-background-200/60 hover:border-primary-300/50 transition-colors cursor-pointer group"
            >
              <div className="flex items-start justify-between mb-3">
                <span className="px-2 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-md whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-400">{item.count}</span>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <div className="mt-3 flex items-center text-xs text-primary-500">
                <span>浏览合集</span>
                <i className="ri-arrow-right-line ml-1"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}